export default __webpack_public_path__ + "static/media/subscription_feature_002.a20d92df.svg";